export const PICKUP_LOCATIONS_QUERY_KEY = 'pickup-locations';
export const PICKUP_LOCATION_QUERY_KEY = 'pickup-location';
